import Geocode from "react-geocode";
// import moment from "moment";
import moment from "moment-timezone";
import PtsAlert from "../component/givBee/ptsAlert/PtsAlert";
import store from "../redux/store";

export const getLatLongMapData = async (line, city, country, state) => {
  let mapObj = {};
  let newAddress = `${line} ${city} ${state} ${country}`;
  let googleLocationAPIKey = "AIzaSyC2X652RPdeR7LYXtbK6X7Vemh_VEQdgMM";
  await Geocode.fromAddress(newAddress, googleLocationAPIKey).then(
    (response) => {
      if (response.results) {
        let latlongdata = response.results[0].geometry.location;
        mapObj = {
          line: line,
          city: city,
          country: country,
          state: state,
          title: city + "," + country,
          lat: latlongdata.lat,
          lng: latlongdata.lng,
        };
      }
    },
    (error) => {
      PtsAlert.error(error);
    }
  );

  return mapObj;
};

//   return mapObj;
// };

export const isNull = (input) => {
  if (undefined === input || null === input) {
    return true;
  }
  return false;
};

export const isNullOrEmpty = (input) => {
  if (undefined === input || null === input || input === "") {
    return true;
  }
  if (input?.toString().trim() === "") {
    return true;
  }
  return false;
};

export const getAddressAsText = (address) => {
  if (isNull(address)) {
    return "";
  }
  let finalAddress = "";
  let addressLine1 = address.line1;
  if (addressLine1 && addressLine1.length > 0) {
    finalAddress = addressLine1.toString().trim() + ", ";
  }
  let addressLine2 = address.line2;
  if (addressLine2 && addressLine2.length > 0) {
    finalAddress = finalAddress + addressLine2.toString().trim() + ", ";
  }

  let addressLine = address.line;
  if (addressLine && addressLine.length > 0) {
    finalAddress = finalAddress + addressLine.toString().trim() + ", ";
  }

  let city = address.city;
  if (city && city.length > 0) {
    finalAddress = finalAddress + city.toString().trim() + ", ";
  }

  let state = address.statevo;
  if (state && state.name && state.name.toString().length > 0) {
    finalAddress = finalAddress + state.name.toString().trim() + ", ";
    if (
      state.countryvo &&
      state.countryvo.name &&
      state.countryvo.name.toString().length > 0
    ) {
      finalAddress =
        finalAddress + state.countryvo.name.toString().trim() + ", ";
    }
  } else {
    state = address.state;
    if (state && state.code && state.code.toString().length > 0) {
      finalAddress = finalAddress + state.code.toString().trim() + ", ";
      if (
        state.countryvo &&
        state.countryvo.name &&
        state.countryvo.name.toString().length > 0
      ) {
        finalAddress =
          finalAddress + state.countryvo.name.toString().trim() + ", ";
      }
      if (
        state.country &&
        state.country.isocode &&
        state.country.isocode.toString().length > 0
      ) {
        finalAddress =
          finalAddress + state.country.isocode.toString().trim() + ", ";
      }
    }
  }

  let pin = address.zipcode;
  if (pin && pin.length > 0) {
    finalAddress = finalAddress + pin.toString().trim();
  } else if (address.zipcode && address.zipcode > 0) {
    finalAddress = finalAddress + address.zipcode.toString().trim();
  }

  let zip = address.zipCode;
  if (zip && zip.length > 0) {
    finalAddress = finalAddress + zip.toString().trim();
  }

  return finalAddress;
};

export const toCamelCase = (string) => {
  String.prototype.toCamelCase = function () {
    return this.substring(0, 1).toUpperCase() + this.substring(1);
  };
  return string.toCamelCase();
};

const equalsIgnoreCase = (string1, string2) => {
  if (
    undefined === string1 ||
    null === string1 ||
    undefined === string2 ||
    null === string2
  ) {
    return false;
  }
  if (
    string1.toString().trim().toUpperCase() ===
    string2.toString().trim().toUpperCase()
  ) {
    return true;
  }

  return false;
};
export const maxFieldLength = (characters) => {
  let maxLength = PtsAlert.error(
    "The size of this field is limited to " + characters + " characters only"
  );

  return maxLength;
};

export const getRolePermission = (privilegeList) => {
  let allPermission = false;
  let createPermission = false;
  let readPermission = false;
  let updatePermission = false;
  let deletePermission = false;
  if (privilegeList.length > 0) {
    for (let i = 0; i < privilegeList.length; i++) {
      switch (privilegeList[i].toLowerCase()) {
        case "*":
          allPermission = true;
          createPermission = true;
          readPermission = true;
          updatePermission = true;
          deletePermission = true;
          break;
        case "create":
          createPermission = true;
          readPermission = true;
          break;
        case "update":
          updatePermission = true;
          readPermission = true;
          break;
        case "delete":
          deletePermission = true;
          readPermission = true;
          break;
        default:
          break;
      }
    }
  }

  return [
    allPermission,
    createPermission,
    readPermission,
    updatePermission,
    deletePermission,
  ];
};
const einNumberAutoFormat = (einNumber) => {
  const number = einNumber.trim().replace(/[^0-9]/g, "");

  if (number.length < 11) return number.replace(/(\d{2})(\d{1})/, "$1-$2");
};
export const urlPattern = (str) => {
  try {
    const input = str.match(/^https?:\/\//i) ? str : `https://${str}`;
    const url = new URL(input);
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
};

export const getLogo = () => {
  let imageData = "";
  if (store.getState().appUserData.logoData?.logo !== null) {
    imageData = store.getState().appUserData?.logoData?.logo;
  }
  return imageData;
};
export const base64ToImage = (base64Data) => {
  let logoData = store.getState().appUserData?.logoData?.logo;
  if (logoData !== null && logoData !== "") {
    return (
      <img
        src={"data:image/png;base64," + logoData}
        style={{ maxHeight: "2em" }}
        alt="logo"
      />
    );
  }
};
export const phoneNumberFormate = (phoneNumber) => {
  let number = phoneNumber;
  if (phoneNumber) {
    number = phoneNumber.match(/\d{3}(?=\d{2,3})|\d+/g)?.join("-");
  }

  return number;
};
export const viewPhoneNumberFormate = (phoneNumber) => {
  let number = phoneNumber;
  if (phoneNumber) {
    number = phoneNumber.match(/\d{3}(?=\d{2,3})|\d+/g).join("-");
  }

  return number;
};
export const tollFreeNumberFormate = (phoneNumber) => {
  let number = phoneNumber;
  if (phoneNumber) {
    if (number.length === 2 || number.length === 6 || number.length === 10) {
      number += "-";
    }
  }

  return number;
};
export const viewTollFreeNumberFormate = (phoneNumber) => {
  let reverseNumber = phoneNumber?.toString().split("").reverse().join("");
  let formatedNumber =
    reverseNumber?.substring(0, 4) +
    "-" +
    reverseNumber?.substring(4, 7) +
    "-" +
    reverseNumber?.substring(7, 10);
  formatedNumber = formatedNumber.split("").reverse().join("");
  if (reverseNumber?.length > 10) {
    formatedNumber =
      reverseNumber?.substring(10).split("").reverse().join("") +
      "-" +
      formatedNumber;
  }
  return formatedNumber;
};

export const materialTablePageSize = () => {
  let pageSize = [20, 50, 100, 200, 500, 1000];

  return pageSize;
};

const ptsDateFormat = (dateTime) => {
  if (dateTime === null) {
    return "";
  }
  let date = new Date(dateTime);
  let localDateTimeFormate = moment(date)?.format("MM/DD/YYYY");

  return localDateTimeFormate;
};

const topNavMenu = (dateTime) => {
  let MenuList = [
    {
      uiname: "Dashboard",
      pageid: "/dashboard",
      id: 1,
    },
    {
      uiname: "Messages",
      pageid: "/messages",
      id: 2,
    },
    {
      uiname: "Qwik Text",
      pageid: "/qwiktext",
      id: 3,
    },
    {
      uiname: "Groups",
      pageid: "/groups",
      id: 4,
    },
    {
      uiname: "Contacts",
      pageid: "/contacts",
      id: 5,
    },
    {
      uiname: "Scheduled Sends",
      pageid: "/scheduledSends",
      id: 6,
    },
    {
      uiname: "Send History",
      pageid: "/sendHistory",
      id: 7,
    },
    {
      uiname: "Settings",
      pageid: "/settings",
      id: 8,
    },
  ];

  return MenuList;
};
const adminTopNavMenu = (dateTime) => {
  let MenuList = [
    {
      uiname: "Dashboard",
      pageid: "/APDashboard",
      id: 1,
    },
    {
      uiname: "Registration",
      pageid: "/registrationList",
      id: 2,
    },
    {
      uiname: "Admin Users",
      pageid: "/appUserList",
      id: 3,
    },
    {
      uiname: "Email Template",
      pageid: "/emailTemplate",
      id: 4,
    },
    {
      uiname: "T & C Management",
      pageid: "/aptermsConditionsList",
      id: 5,
    },
    {
      uiname: "Privacy Policy",
      pageid: "/privacyPolicyList",
      id: 6,
    },
    {
      uiname: "Settings",
      pageid: "/apSettings",
      id: 8,
    },
  ];

  return MenuList;
};

const getUtcToLocalDateTime = (dateTime) => {
  if (!dateTime) return "";
  const timeZone = store.getState().appUserData?.organizationDetails?.timezone;
  let formattedDate;
  formattedDate = moment
    .utc(dateTime)?.tz(timeZone?.name)?.format("MM/DD/YYYY - hh:mm A");
  return formattedDate;
};

const getUtcToLocalDateTimeZone = (dateTime, showAbbreviation) => {
  if (!dateTime) return "";

  // Fetch timezone from Redux state
  const timeZone = store.getState().appUserData?.organizationDetails?.timezone;

  let formattedDate;
  if (timeZone?.name) {
    formattedDate = moment
      .utc(dateTime)?.tz(timeZone?.name)?.format("MM/DD/YYYY - hh:mm A");

    if (showAbbreviation) {
      formattedDate += ` (${timeZone?.abbreviation || ""})`;
    }
  } else {
    formattedDate = moment.utc(dateTime)?.local()?.format("MM/DD/YYYY - hh:mm A");
  }

  return formattedDate;
};

const getUtcToLocal = (dateTime) => {
  if (dateTime === null) {
    return "";
  }
  let timeZone = store.getState().appUserData?.organizationDetails?.timezone;
  let localDateFormate = "";
  if (timeZone !== null && timeZone !== undefined) {
    let utcCutoff = moment(dateTime);
    localDateFormate = utcCutoff
      .tz(timeZone?.abbreviation)?.format("MM/DD/YYYY");
  } else {
    localDateFormate = moment(dateTime)?.format("MM/DD/YYYY");
  }

  return localDateFormate;
};

const getUtcToEventLocalTime = (dateTime) => {
  if (dateTime === null) {
    return "";
  }
  let timeZone = store.getState().businessDomain?.eventTimeZone;
  let localDateFormate = "";
  if (timeZone !== null && timeZone !== undefined) {
    let utcCutoff = moment(dateTime);
    localDateFormate = utcCutoff
      .tz(timeZone?.abbreviation)?.format("MM/DD/YYYY");
  } else {
    localDateFormate = moment(dateTime)?.format("MM/DD/YYYY");
  }

  return localDateFormate;
};

const getUtcToEventTimezone = (dateTime, showAbbreviation) => {
  if (!dateTime) {
    return "";
  }

  let timeZone = store.getState().businessDomain?.eventTimeZone;
  let formattedDate = "";

  if (timeZone?.name) {
    formattedDate = moment
      .utc(dateTime)?.tz(timeZone?.name)?.format("MM/DD/YYYY - hh:mm A");

    if (showAbbreviation) {
      formattedDate += ` (${timeZone?.abbreviation || ""})`;
    }
  } else {
    formattedDate = moment
      .utc(dateTime)?.local()?.format("MM/DD/YYYY - hh:mm A");
  }

  return formattedDate;
};

export const convertUTCDateToUserTimeZoneViewDateFormate = (UtcDate) => {
  let timeZone = moment.tz.guess();
  // let timeZone = store.getState().appUserData?.organizationDetails?.timezone;

  let utcTimeZone = "";
  if (timeZone !== null) {
    let utcCutoff = moment(UtcDate);

    utcTimeZone = utcCutoff.tz(timeZone)?.format("MM/DD/YYYY (ddd) - hh:mm A");
  } else {
    utcTimeZone = moment(UtcDate)?.format("MM/DD/YYYY (ddd) - hh:mm a");
  }
  return utcTimeZone;
};

export const getScheduledDateTime = (UtcDate) => {
  if (!UtcDate) return ""; // Handle null or undefined input safely

  let timeZone = store.getState().appUserData?.organizationDetails?.timezone;
  let formattedDate = "";

  if (timeZone?.name) {
    // Convert UTC to the specified timezone
    formattedDate = moment
      .utc(UtcDate)?.tz(timeZone?.name)?.format("YYYY-MM-DDTHH:mm:ss.SSS");
  } else {
    // Fallback to local timezone if no organization timezone is found
    formattedDate = moment
      .utc(UtcDate)?.local()?.format("MM/DD/YYYY (ddd) - hh:mm a");
  }

  return formattedDate;
};
const isRestrictedKeyWord = (input) => {
  let keyword = [
    "HELP",
    "CANCEL",
    "GIVBEE",
    "STOP",
    "UNSUBSCRIBE",
    "QUIT",
    "REMOVE",
    "OFF",
    "OPTIN",
    "OPTOUT",
    "OUTPUT",
    "DELETE",
    "STOPALL",
    "ARRET",
    "START",
    "END",
    "50/50",
    "SWEEPSTAKES",
    "RAFFLE",
    "GAMBLE",
    "GAMBLING"
  ];

  const words = input.toUpperCase().split(/\s+/);
  return words.some(word => keyword.includes(word));
};

const isRestrictedForMessageKeyWord = (input = "") => {
  const text = input.toUpperCase();

  const shortLinkPattern =
    /(https?:\/\/)?(www\.)?\b(BIT\.LY|BITLY\.COM|TINYURL\.COM|T\.CO|GOO\.GL|REBRAND\.LY|IS\.GD|LINK\.YOURBRAND\.COM)(\/\S*)?\b/;

  const keywordPattern =
    /\b(FREE|TINYURL|BIT.LY|SWEEPSTAKES|RAFFLE|GAMBLE|GAMBLING)\b/;

  const specialPattern = /50\s*\/\s*50/;

  return (
    shortLinkPattern.test(text) ||
    keywordPattern.test(text) ||
    specialPattern.test(text)
  );
};

export const getSmsQuestionType = (type, group) => {
  let questionType = type;
  if (questionType === "Any") {
    questionType = "";
  } else if (questionType === "Email") {
    questionType = `Thank you. What is your email?`;
  } else if (questionType === "FirstName") {
    questionType = `What is your first name?`;
  } else if (questionType === "FullName") {
    questionType = `Thank you! Please tell us your full name.`;
  } else if (questionType === "LastName") {
    questionType = `What is your last name?`;
  } else if (questionType === "Pledge") {
    questionType = `Thank you. How much would you like to donate? Please enter an amount.`;
  } else if (questionType === "YesNo") {
    questionType = `Yes or No?`;
  } else if (questionType === "ConfirmGroup") {
    questionType = `Reply YES if you want to be added to our ${group} group. If not reply NO.`;
  } else if (questionType === "SelectGroup") {
    questionType = `Which text group do you want to be added to? (spell exactly)`;
  } else {
    questionType = "";
  }
  return questionType;
};
export const toCamelCaseUL = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const emailValidation = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};

export const formatWithCommas = (number) => {
  return number?.toLocaleString();
};
export const countLetters = (template) => {
  let companyName = store.getState().appUserData?.organizationDetails?.name;
  let eventState = store.getState().applicationState.eventState;
  let eventStartDate = moment(eventState?.eventStartDate)?.format("MM/DD/YYYY");
  let eventEndDate = moment(eventState?.eventEndDate)?.format("MM/DD/YYYY");
  let placeholders = {
    "Org Name": companyName,
    "Event Name": eventState?.eventName,
    "Event Start Date": eventStartDate,
    "Event End Date": eventEndDate,
  };
  let processedText = template;
  for (const [key, value] of Object.entries(placeholders)) {
    const regex = new RegExp(`{{\\s*${key}\\s*}}`, "g"); // Handles {{key}} with optional spaces
    processedText = processedText?.replace(regex, value);
  }

  const letterCount = processedText?.length;

  return letterCount;
};

export const trimLetters = (template) => {
  let companyName = store.getState().appUserData?.organizationDetails?.name;
  let eventState = store.getState().applicationState.eventState;

  let eventStartDate = moment(eventState?.eventStartDate)?.format("MM/DD/YYYY");
  let eventEndDate = moment(eventState?.eventEndDate)?.format("MM/DD/YYYY");

  let placeholders = {
    "Org Name": companyName,
    "Event Name": eventState?.eventName,
    "Event Start Date": eventStartDate,
    "Event End Date": eventEndDate,
  };

  let processedText = template;

  // Replace known placeholders with actual values
  for (const [key, value] of Object.entries(placeholders)) {
    const regex = new RegExp(`{{\\s*${key}\\s*}}`, "g");
    processedText = processedText?.replace(regex, value ?? "");
  }

  // 1️⃣ Match ALL placeholders like {{First Name}}
  const placeholderRegex = /{{\s*[^}]+\s*}}/g;
  const placeholdersFound = processedText?.match(placeholderRegex) || [];

  // Remove placeholders temporarily
  let textWithoutPlaceholders = processedText?.replace(placeholderRegex, "");

  // 2️⃣ Count special characters ONLY outside placeholders
  const doubleCountRegex = /[\^{}\[\]\\~|€]/g;

  const normalLength = textWithoutPlaceholders?.length;
  const doubleCountChars =
    textWithoutPlaceholders?.match(doubleCountRegex)?.length || 0;

  // 3️⃣ Add placeholder length back (normal count)
  const placeholdersLength = placeholdersFound?.reduce(
    (sum, p) => sum + p.length,
    0
  );

  const letterCount =
    normalLength + doubleCountChars + placeholdersLength;

  return letterCount;
};

const formatCardNumber = (number) => {
  return number
    .replace(/\D/g, "") // Remove non-digit characters
    .slice(0, 16) // Limit to 16 digits
    .replace(/(\d{4})(?=\d)/g, "$1 ") // Add space after every 4 digits, but not at the end
    .trim(); // Remove trailing space
};

const truncateString = (str, maxLength) => {
  if (str?.length > maxLength) {
    return str.slice(0, maxLength) + "...";
  }
  return str;
};

const getShortName = (name) => {
  const nameParts = name.trim().split(" ");
  const initials =
    nameParts.length > 1
      ? nameParts[0][0] + nameParts[nameParts.length - 1][0] // First and last name initials
      : nameParts[0][0]; // Single name case
  return initials.toUpperCase();
};

const getBrowserType = () => {
  const userAgent = navigator.userAgent;
  if (userAgent.includes("Chrome") && !userAgent.includes("Edg"))
    return "Chrome";
  if (userAgent.includes("Firefox")) return "Firefox";
  if (userAgent.includes("Safari") && !userAgent.includes("Chrome"))
    return "Safari";
  if (userAgent.includes("Edg")) return "Edge";
  if (userAgent.includes("MSIE") || userAgent.includes("Trident"))
    return "Internet Explorer";
  return "Unknown";
};

export const getArrayElement = (arr, element) => {
  return Array.isArray(arr) && arr.length > 0 ? arr[element] : null;
};

export const setFavicon = (iconPath) => {
  const link =
    document.querySelector("link[rel*='icon']") ||
    document.createElement("link");
  link.type = "image/x-icon";
  link.rel = "icon";
  link.href = iconPath;
  document.getElementsByTagName("head")[0].appendChild(link);
};

export const getMonthList = () => {
  return [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
  ];
};
export const getMonthNumber = (monthInNumber) => {
  // monthInNumber = Number(monthInNumber);
  let months = {
    JAN: "01",
    FEB: "02",
    MAR: "03",
    APR: "04",
    MAY: "05",
    JUN: "06",
    JUL: "07",
    AUG: "08",
    SEP: "09",
    OCT: "10",
    NOV: "11",
    DEC: "12",
  };
  return months[monthInNumber];
};

export const getColorCodeList = () => {
  return [
    {
      color: "Blue",
      hashColor: "#0a4bf5 ",
      description: null,
      displaySequence: 1.0,
      id: 1,
    },
    {
      color: "Blue-Grey ",
      hashColor: "#31a2cd ",
      description: null,
      displaySequence: 2.0,
      id: 2,
    },
    {
      color: "Light Blue ",
      hashColor: "#7ecae7 ",
      description: null,
      displaySequence: 3.0,
      id: 3,
    },
    {
      color: "Ocean Blue ",
      hashColor: "#256ed9",
      description: null,
      displaySequence: 4.0,
      id: 4,
    },
    {
      color: "Sky Blue ",
      hashColor: "#148deb ",
      description: null,
      displaySequence: 5.0,
      id: 5,
    },
    {
      color: "Violet",
      hashColor: "#583ac4 ",
      description: null,
      displaySequence: 6.0,
      id: 6,
    },
    {
      color: "Purple ",
      hashColor: "#8722dc ",
      description: null,
      displaySequence: 7.0,
      id: 7,
    },
    {
      color: "Rose",
      hashColor: "#d02e49",
      description: null,
      displaySequence: 8.0,
      id: 8,
    },
    {
      color: "Hot Pink ",
      hashColor: "#d02eb5 ",
      description: null,
      displaySequence: 9.0,
      id: 9,
    },
    {
      color: "Pink",
      hashColor: "#e77ed5 ",
      description: null,
      displaySequence: 10.0,
      id: 10,
    },
    {
      color: "Red",
      hashColor: "#d52867",
      description: null,
      displaySequence: 11.0,
      id: 11,
    },
    {
      color: "Orange-Red ",
      hashColor: "#e46019",
      description: null,
      displaySequence: 12.0,
      id: 12,
    },
    {
      color: "Orange ",
      hashColor: "#efa10f ",
      description: null,
      displaySequence: 13.0,
      id: 13,
    },
    {
      color: "Gold",
      hashColor: "#edbb11 ",
      description: null,
      displaySequence: 14.0,
      id: 14,
    },
    {
      color: "Yellow ",
      hashColor: "#edd311 ",
      description: null,
      displaySequence: 15.0,
      id: 15,
    },
    {
      color: "Yellow-Green ",
      hashColor: "#ced529 ",
      description: null,
      displaySequence: 16.0,
      id: 16,
    },
    {
      color: "Light Green ",
      hashColor: "#83cd31",
      description: null,
      displaySequence: 17.0,
      id: 17,
    },
    {
      color: "Green",
      hashColor: "#42be3f ",
      description: null,
      displaySequence: 18.0,
      id: 18,
    },
    {
      color: "Forest Green ",
      hashColor: "#56a855",
      description: null,
      displaySequence: 19.0,
      id: 19,
    },
    {
      color: "Aqua",
      hashColor: "#2ad3cd ",
      description: null,
      displaySequence: 20.0,
      id: 20,
    },
  ];
};

export const isExpiryValid = (expiry) => {
  const match = expiry.match(/^(\d{2})\/(\d{4})$/);
  if (!match) return false;

  const [, mmStr, yyyyStr] = match;
  const month = parseInt(mmStr, 10);
  const year = parseInt(yyyyStr, 10);

  if (month < 1 || month > 12) return false;

  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth() + 1;

  // Expiry is valid if year greater, or same year and month >= current month
  return year > currentYear || (year === currentYear && month >= currentMonth);
};

function sortList(list, column, direction = "asc") {
  if (!Array.isArray(list)) return [];

  return [...list].sort((a, b) => {
    let valA = a[column] ? a[column].toString().toLowerCase() : "";
    let valB = b[column] ? b[column].toString().toLowerCase() : "";

    if (valA < valB) return direction === "asc" ? -1 : 1;
    if (valA > valB) return direction === "asc" ? 1 : -1;
    return 0;
  });
}

export const formatCompactNumber = (value) => {
  const formatter = new Intl.NumberFormat("en", {
    notation: "compact",
    compactDisplay: "short",
    maximumFractionDigits: 1,
  });
  return formatter?.format(value);
};

export const base64ToUrl = (base64, mime = "application/octet-stream") => {
  const binary = atob(base64.replace(/^data:.*;base64,/, ""));
  const len = binary.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  const blob = new Blob([bytes], { type: mime });
  return URL.createObjectURL(blob);
};

export const getPlanType = (planType) => {
  if (!planType) return "";

  switch (planType.toLowerCase()) {
    case "daily":
      return "day";
    case "monthly":
      return "month";
    case "yearly":
      return "year";
    case "onetime":
      return "event";
    case "custommonthly":
      return "month";
    case "customyearly":
      return "year";
    case "customonetime":
      return "event";
    case "legacymonthly":
      return "month";
    case "legacyyearly":
      return "year";
    case "legacyonetime":
      return "event";
    default:
      return planType;
  }
};

export const maskEIN = (ein) => {
  if (!ein) return "";

  const digits = ein.replace(/\D/g, "");
  if (digits.length !== 9) return ein;

  const lastFour = digits.slice(-4);

  return `*****${lastFour}`;
};

export const formatTimeToAMPM = (time) => {
  if (!time) return "";

  const [hours, minutes] = time?.split(":");
  let h = parseInt(hours, 10);
  const ampm = h >= 12 ? "pm" : "am";

  h = h % 12;
  h = h ? h : 12;

  return `${h}:${minutes} ${ampm}`;
};

const Utils = {
  getLatLongMapData,
  einNumberAutoFormat,
  toCamelCase,
  getAddressAsText,
  isNullOrEmpty,
  isNull,
  equalsIgnoreCase,
  maxFieldLength,
  getRolePermission,
  urlPattern,
  getLogo,
  base64ToImage,
  phoneNumberFormate,
  materialTablePageSize,
  ptsDateFormat,
  topNavMenu,
  adminTopNavMenu,
  tollFreeNumberFormate,
  viewPhoneNumberFormate,
  viewTollFreeNumberFormate,
  getUtcToLocalDateTimeZone,
  getUtcToLocalDateTime,
  getUtcToLocal,
  getScheduledDateTime,
  isRestrictedKeyWord,
  isRestrictedForMessageKeyWord,
  convertUTCDateToUserTimeZoneViewDateFormate,
  getSmsQuestionType,
  toCamelCaseUL,
  emailValidation,
  formatWithCommas,
  countLetters,
  trimLetters,
  formatCardNumber,
  truncateString,
  getShortName,
  getBrowserType,
  getArrayElement,
  setFavicon,
  getMonthList,
  getMonthNumber,
  getColorCodeList,
  isExpiryValid,
  sortList,
  formatCompactNumber,
  base64ToUrl,
  getPlanType,
  maskEIN,
  formatTimeToAMPM,
  getUtcToEventTimezone,
  getUtcToEventLocalTime,
};
export default Utils;
